import React from "react";
import { useResource, useNavigation } from "@refinedev/core";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Save, Trash2 } from "lucide-react";
import { PageHeader } from "@/components/ui/page-header";

interface EditPageProps {
  title?: string;
  children: React.ReactNode;
  saveButtonProps?: React.ButtonHTMLAttributes<HTMLButtonElement> & { loading?: boolean };
  isLoading?: boolean;
  canDelete?: boolean;
  onDelete?: () => void;
  footerButtons?: React.ReactNode;
  headerButtons?: React.ReactNode;
}

export const EditPage: React.FC<EditPageProps> = ({
  title,
  children,
  saveButtonProps,
  isLoading,
  canDelete,
  onDelete,
  footerButtons,
  headerButtons,
}) => {
  const { resource } = useResource();
  const { goBack } = useNavigation();
  const displayTitle = title || `Edit ${resource?.meta?.label || resource?.name || ""}`;

  return (
    <div>
      <PageHeader
        title={
          <div className="flex items-center gap-4">
            <Button variant="ghost" size="icon" onClick={goBack} className="-ml-2">
              <ArrowLeft className="h-4 w-4" />
            </Button>
            <span>{displayTitle}</span>
          </div>
        }
        actions={headerButtons}
      />
      <div className="space-y-6">
        {children}
      </div>
      <div className="flex items-center justify-between mt-6">
        <div>
          {canDelete && (
            <Button variant="destructive" onClick={onDelete}>
              <Trash2 className="mr-2 h-4 w-4" />
              Delete
            </Button>
          )}
        </div>
        <div className="flex items-center gap-2">
          {footerButtons}
          {saveButtonProps && (
            <Button type="submit" disabled={saveButtonProps.disabled || isLoading} {...saveButtonProps}>
              <Save className="mr-2 h-4 w-4" />
              Save
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
